import addToCalendarCss from '@culturehq/add-to-calendar/dist/styles.css?raw';
import { Device, from, until } from '@helpers/media';
import BodyBgAlt from '@img/shapes/body-bg-alt.png';
import BodyBg from '@img/shapes/body-bg.png';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import { createGlobalStyle } from 'styled-components';
import resetCss from '../../../../client/reset.css?raw';
import { fluid, fluidAdjusted } from '@helpers/fluid';
import { gradientStyle, headingStyles } from '@helpers/typography';
import brand from '@helpers/brand';
// TODO: import font
const GlobalStyles = createGlobalStyle `
  // TODO: font  
  ${resetCss}
  ${addToCalendarCss}

  :root {
    --global--site-padding: ${fluid(18, 140, Device.Mobile, Device.ActualDesktop)};
    --accentColor: initial;
    --accentContrastColor: initial;
    --bgColor: initial;
    --fgColor: initial;
    --gutterWidth: initial;
    --headerHeight: initial;
    --sectionSpacing: initial;
    --sitePadding: initial;
    --siteWidth: initial;
    --fontFamily: 'sofia-pro', sans-serif;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
  // TODO: font and colour styles
    overscroll-behavior-x: none;
    font-family: var(--fontFamily);

    background-image: url(${BodyBg});
    background-size: 100% auto;
    background-position: center 100vh;
    background-repeat: repeat-y;

    &[data-page-theme='pink'] {
      background-image: url(${BodyBgAlt});
    }
  }

  img {
    max-width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  span {
    display: inline-block;
  }

  sup {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  .hidden {
    display: none;
    visibility: none;
  }

  #main {
    position: relative;
    z-index: 1;
    padding-top: var(--headerHeight);
  }

  .article-content-layout {
    &__grid {
      display: grid;
      column-gap: var(--gutterWidth);
      grid-template-columns: repeat(12, 1fr);
      position: relative;
      z-index: 2;

      @media ${until(Device.Tablet)} {
        row-gap: 32px;
      }
    }

    &__container {
      position: relative;
      display: block;
    }

    &__section-wrapper {
      --sectionSpacingTop: 40px;
      --sectionSpacingBottom: 40px;

      position: relative;
      scroll-margin: var(--headerHeight) 0 0;

      @media ${from(Device.Tablet)} {
        --sectionSpacingTop: 60px;
        --sectionSpacingBottom: 60px;
      }

      &[data-allow-scroll-margin='true'] {
        overflow: clip;
      }

      &[data-flush='top'] {
        --sectionSpacingTop: 0;

        @media ${from(Device.Tablet)} {
          --sectionSpacingTop: 0;
        }
      }

      &[data-flush='bottom'] {
        --sectionSpacingBottom: 0;

        @media ${from(Device.Tablet)} {
          --sectionSpacingBottom: 0;
        }
      }

      &[data-flush='both'] {
        --sectionSpacingTop: 0;
        --sectionSpacingBottom: 0;

        @media ${from(Device.Tablet)} {
          --sectionSpacingTop: 0;
          --sectionSpacingBottom: 0;
        }
      }

      /* Negative margin bottom to force overlap */
      &[data-overlap-bottom='true'] {
        margin-bottom: calc(var(--sectionSpacingBottom) * -1);
      }
    }

    &__section-wrapper-inner {
      --sitePadding: 24px;
      --siteWidth: 1700px;
      --gutterWidth: 16px;
      margin: 0 auto;
      max-width: calc(var(--siteWidth) + var(--sitePadding) + var(--sitePadding));
      padding: 0 var(--sitePadding);
      width: 100%;

      @media ${from(Device.Tablet)} {
        --gutterWidth: 32px;
      }
      color: var(--fgColor);
      padding-top: var(--sectionSpacingTop);
      padding-bottom: var(--sectionSpacingBottom);
    }

    &__main-content {
      grid-column: span 12;

      @media ${from(Device.TabletLarge)} {
        grid-column: 1 / span 7;
      }

      @media ${from(Device.Desktop)} {
        grid-column: 2 / span 6;
      }
    }

    &__side-content {
      grid-column: span 12;

      @media ${from(Device.TabletLarge)} {
        grid-column: 8 / span 4;
      }

      @media ${from(Device.Desktop)} {
        grid-column: 8 / span 4;
      }
    }
  }

  .site-map {
    --sitePadding: 24px;
    --headerClearance: ${fluid(120, 200)};
    
    max-width: 1820px;
    padding: var(--headerClearance) var(--sitePadding) 100px;
    margin: 0 auto;
    
    @media ${from(Device.Tablet)} {
      --sitePadding: 60px;
    }

    h1 {
      ${headingStyles}
      ${gradientStyle};
      --titleColor: ${brand.secondary.red5};
      font-size: ${fluidAdjusted(32, 64)};
      line-height: ${fluidAdjusted(60, 90)};
      color: var(--titleColor);
      position: relative;
    }

    ul {
      list-style: circle;
      padding-left: 18px;
      line-height: 1.5;

      ul {
        margin-left: var(--sitePadding);
        padding-left: 0;
      }
    }

    li {
      margin-bottom: .5em;

      &:first-child {
        margin-top: .5em;
      }
    }

    a {
      color: inherit;
    }
  }

  /* Button line fix for Safari MacOS */
  _:default:not(:root:root),
  ${ButtonStyles.Fill} {
    right: -1px;
  }
`;
export default GlobalStyles;
